<div class="video-camera-panel webcam">
	<video #video class="webcam-live" id="webcam-live" autoplay muted playsinline [hidden]="cameraError"></video>
	<div *ngIf="cameraError" class="camera-error-state">
		<p class="camera-error-message">{{ cameraError }}</p>
		<button type="button" class="btn btn-outline-secondary btn-sm" (click)="captureCamera()">Retry</button>
	</div>
</div>
